import { useEffect, Fragment } from "react";
import { useLang } from "@/lib/i18n";
import { LEGAL, LEGAL_DETAILS, PLACEHOLDER_LABELS } from "@/lib/legal";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

const fill = (text) =>
  text.split(/(\{\w+\})/g).map((part, i) => {
    const key = part.match(/^\{(\w+)\}$/)?.[1];
    if (!key) return <Fragment key={i}>{part}</Fragment>;
    const value = LEGAL_DETAILS[key];
    return value ? <Fragment key={i}>{value}</Fragment> : (
      <mark key={i} data-testid={`legal-placeholder-${key}`} className="rounded bg-amber-400/15 px-1.5 py-0.5 font-semibold text-amber-300">[{PLACEHOLDER_LABELS[key]}]</mark>
    );
  });

export default function LegalPage({ page }) {
  const { lang } = useLang();
  const doc = LEGAL[lang][page];
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${doc.title} · Autovantis`;
  }, [doc.title]);

  return (
    <div className="min-h-screen bg-[#060A14] text-white">
      <Header />
      <main data-testid={`legal-page-${page}`} className="bg-gradient-to-b from-[#0B1428] to-[#060A14]">
        <div className="mx-auto max-w-3xl px-5 pb-24 pt-16 lg:pt-20">
          <h1 data-testid="legal-title" className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">{doc.title}</h1>
          <p className="mt-5 text-base leading-relaxed text-slate-300">{doc.intro}</p>
          <div className="mt-12 space-y-10 rounded-3xl border border-white/10 bg-white/[0.04] p-7 shadow-[0_20px_50px_-30px_rgba(0,0,0,.6)] sm:p-10">
            {doc.sections.map((s) => (
              <section key={s.h}>
                <h2 className="font-display text-lg font-bold text-white sm:text-xl">{s.h}</h2>
                <div className="mt-3 space-y-2 text-[15px] leading-relaxed text-slate-300">
                  {s.p.map((p, i) => <p key={i}>{fill(p)}</p>)}
                </div>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
